import { render } from "./DadosContaPagarModal.vue?vue&type=template&id=22acf958&scoped=true&ts=true"
import script from "./DadosContaPagarModal.vue?vue&type=script&lang=ts"
export * from "./DadosContaPagarModal.vue?vue&type=script&lang=ts"

import "./DadosContaPagarModal.vue?vue&type=style&index=0&id=22acf958&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22acf958"]])

export default __exports__